query Parameter(
    $id: ID!
) {
    parameter(id: $id) {
        id
        name(language: "en") {
            language
            text
        }
        dataType
        values {
            id
            label(language: "en") {
                language
                text
            }
        }
        units
    }
}
